<template>
  <g>
    <circle v-for="(dot, index) in dots"
      :key="'dot-'+index"
      :stroke="dot.stroke"
      :stroke-width="strokeWidth"
      :cx="dot.cx"
      :cy="dot.cy"
      :fill="dotFill(dot, index)"
      :r="dotRadio(index)"
      @mouseover="onMouseover(dot, index)"
      @mouseleave="onMouseleave()"
    />
  </g>
</template>

<script>
// multiplier to help positioning the tooltip horizontally
// close to the dot without cover it.
const TRANSLATE_FACTOR = 3.5;

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    metrics: {
      type: Array,
      required: true,
    },
    xScale: {
      type: Function,
      required: true,
    },
    yScale: {
      type: Function,
      required: true,
    },
    dimensionKey: {
      type: String,
      required: true,
    },
    strokeWidth: {
      type: Number,
      default: 10,
    },
    maxDotRadio: {
      type: Number,
      default: 4,
    },
    minDotRadio: {
      type: Number,
      default: 3,
    },
    hoveredIndex: {
      type: Number,
    },
    hideOnLeave: {
      type: Boolean,
    },
  },
  computed: {
    dots() {
      return this.data.reduce((acc, d) => {
        const baseObj = {};

        baseObj.d = d;
        baseObj.stroke = 'transparent';

        this.metrics.forEach((mk) => {
          const dotObj = { ...baseObj };

          dotObj.metric = mk.name;
          dotObj.cx = this.xScale(d[this.dimensionKey]);
          dotObj.cy = this.yScale(d[mk.name]);
          dotObj.fill = mk.color;

          acc.push(dotObj);
        });

        return acc;
      }, []);
    },
  },
  methods: {
    onMouseleave() {
      this.$emit('onLeave');
    },
    onMouseover(dot, index) {
      this.$emit('onHover', {
        data: {
          d: dot.d,
          metric: dot.metric,
        },
        hoveredIndex: index,
        position: {
          left: dot.cx + TRANSLATE_FACTOR*(this.maxDotRadio + this.strokeWidth),
          top: dot.cy + this.maxDotRadio + this.strokeWidth,
        },
      });
    },
    dotRadio(index) {
      return this.hoveredIndex === index ? this.maxDotRadio : this.minDotRadio;
    },
    dotFill(dot, index) {
      if (this.hideOnLeave) return this.hoveredIndex === index ? dot.fill : 'none';

      return dot.fill;
    },
  },
};
</script>
